import React from 'react';
import PropTypes from 'prop-types';
import {
  Multiline,
  Typography,
  Flex,
} from '@knockrentals/knock-shared-web-v2';
import { MultiSelectChips } from '../../../../../../../knock-design-system';
import { DividedTabSection } from '../../TabSections';
import { SECTIONS } from '../../constants';
import {
  FIELD_LABELS,
  FIELDS_PLACEHOLDERS,
  KEY_FEATURE_CHIP_FIELD_NAMES,
  NOTES_FIELD,
} from './constants';
import { notesFeaturesPropTypes } from '../../../../prop-types';

const { DESCRIPTION, TITLE } = SECTIONS.NOTES_FEATURES;

const chipValues = (features, fieldName) => {
  const raw = features[fieldName];
  return Array.isArray(raw) ? raw : [];
};

const NotesFeatures = ({ notesFeatures = {}, updateNotesFeatures }) => {
  const handleOnBlur = ({ target: { name, value } }) => {
    updateNotesFeatures({ [name]: value.trim() });
  };
  
  const notesOnChange = (value, { target: { name } }) => {
    updateNotesFeatures({ [name]: value });
  };

  const handleChipChange = (field) => (selectedValues) => {
    updateNotesFeatures({ [field]: selectedValues });
  };

  return (
    <DividedTabSection description={DESCRIPTION} title={TITLE}>
      <Flex flexDirection="column" gap={24}>
        <Multiline
          label={FIELD_LABELS[NOTES_FIELD]}
          name={NOTES_FIELD}
          onBlur={handleOnBlur}
          onChange={notesOnChange}
          placeholder={FIELDS_PLACEHOLDERS[NOTES_FIELD]}
          value={notesFeatures[NOTES_FIELD] || ''}
          variant="outlined"
        />

        <Flex flexDirection="column">
          <Typography variant="subtitle1">Key Features</Typography>

          <Typography color="text.tertiary" variant="caption">
            Type feature name and press Enter.
          </Typography>
        </Flex>

        {KEY_FEATURE_CHIP_FIELD_NAMES.map((field) => (
          <MultiSelectChips
            handleOnChange={handleChipChange(field)}
            id={field}
            key={field}
            label={FIELD_LABELS[field]}
            maxSelections={3}
            placeholder={FIELDS_PLACEHOLDERS[field]}
            values={chipValues(notesFeatures, field)}
          />
        ))}
      </Flex>
    </DividedTabSection>
  );
};

NotesFeatures.propTypes = {
  notesFeatures: notesFeaturesPropTypes,
  updateNotesFeatures: PropTypes.func,
};

export default NotesFeatures;
